import {RemotePostBeneficiaryAddressSuggestionV4} from 'data/usecases';
import {PostBeneficiaryAddressSuggestionV4} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makePostBeneficiaryAddressSuggestionV4 = (): PostBeneficiaryAddressSuggestionV4 =>
	new RemotePostBeneficiaryAddressSuggestionV4(
		makeBFFApiUrl(ProfileChangeDataEndpoints.beneficiaryAddressSuggestionV4),
		makeAuthorizeHttpClientDecorator(),
	);
